import { cn } from '@/lib/utils'

import { formatCents } from './helpers'

/**
 * The wallet preset-amount button grid, shared by the top-up sheet's
 * "Quick amount" picker and the auto-reload dialog's amount field so the
 * two surfaces can never drift on presentation. `value: null` renders no
 * selection (the top-up sheet clears it while a custom amount is typed).
 */
export interface AmountPresetGridProps {
  presetsCents: readonly number[]
  value: number | null
  onSelect: (cents: number) => void
  currency: string
  disabled?: boolean
}

export function AmountPresetGrid({ presetsCents, value, onSelect, currency, disabled }: AmountPresetGridProps) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {presetsCents.map((cents) => {
        const active = value === cents
        return (
          <button
            key={cents}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(cents)}
            className={cn(
              'rounded-md border px-3 py-3 text-sm font-medium transition-colors',
              active
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-border text-foreground hover:border-foreground/30',
              disabled && 'cursor-not-allowed opacity-50',
            )}>
            {formatCents(cents, currency)}
          </button>
        )
      })}
    </div>
  )
}
